import { useMemo } from "react";
import { useTranslation } from "rujira.ui";

type Value = bigint | null | undefined;

export const useRangeFormat = () => {
  const { t } = useTranslation("trade");

  return useMemo(() => {
    const na = t("notAvailable");

    return {
      notAvailable: na,
      formatPct: (v: Value) =>
        v === null || v === undefined
          ? na
          : `${(Number(v) / 1e10).toLocaleDecimal(2)}%`,
      formatSkew: (v: Value) =>
        v === null || v === undefined
          ? na
          : v === 0n
            ? t("balanced")
            : `${(Number(v) / 1e12).toLocaleDecimal(2)}x`,
      formatRatio: (v: Value) =>
        v === null || v === undefined
          ? na
          : `${(Number(v) / 1e12).toLocaleDecimal(2)}x`,
      formatApr: (v: Value) =>
        v === null || v === undefined
          ? na
          : `${(Number(v) / 1e10).toLocaleDecimal(1)}%`,
      formatAge: (days?: number | null) =>
        days === null || days === undefined
          ? na
          : t("ageDays", { count: days, days: days.toLocaleString() }),
    };
  }, [t]);
};
